const URL = {
	INDEX: '',
	HOME: '/:partner',
	FACILITYHOME: '/:partner/:facility',
	// BOOKING_PAGE1: '/:partner/booking/:event_id',
	// BOOKING_PAGE: 'booking',
	BOOKING_DETAIL1: '/:partner/bookingdetail',
	FACILITY_BOOKING_DETAIL1: '/:partner/:facility/bookingdetail',
	BOOKING_DETAIL: 'bookingdetail',
	FACILITY_BOOKING_DETAIL: ':facility/bookingdetail',

	FORGOT_PASSWORD: '/:partner/forgotpassword',
	FACILITY_FORGOT_PASSWORD: '/:partner/:facility/forgotpassword',
	PAYMENT_SUCCESS: '/:partner/paymentsuccess',
	FACILITY_PAYMENT_SUCCESS: '/:partner/:facility/paymentsuccess',
	PAYMENT_SUCCESS1: 'paymentsuccess',
	PAYMENT_FAIL: '/:partner/paymentfails',
	FACILITY_PAYMENT_FAIL: '/:partner/:facility/paymentfails',
	PAYMENT_FAIL2: 'paymentfails',
	RESET_PASSWORD: '/:partner/reset-password/:token_id',
	FACILITY_RESET_PASSWORD: '/:partner/reset-password/:token_id',
	NAVIGATING_PARTNER: '/navigating/:acc/:ref/:partner',
	NAVIGATING_MASQUERADE_PARTNER: '/navigating/:acc/:ref/:masquerade/:partner',

	// account profile 
	PROFILE: '/profileUser',
	USER_ACCOUNT: '/userAccount',

	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react'
}

export default URL
